import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { MessageType } from '../../../../shared/enums/MessageType';
import emit from "cluster";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'receiving-detail',
    templateUrl: './receiving-detail.component.html',
    styleUrls: ['./receiving-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReceivingDetailComponent extends BaseGridEditLineComponent<OrderDetailsBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "OrderDetailsBus";
    }
    @Input() testCode: string = "Z";
    
    @Output() newReceiving = new EventEmitter<boolean>();

    test() {
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderDetailId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl(),
            'manufacturerNumber': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'quantityReceived': new UntypedFormControl(),
            'totalReceived': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl('', Validators.required),
            'quantity': new UntypedFormControl(),
            'usedPartQuantity': new UntypedFormControl(),
            'quantityBilled': new UntypedFormControl(),
            'price': new UntypedFormControl(),
            'warehouseId': new UntypedFormControl()

        });
        this.disableCpSearchDialog();
    }
    setForm() {
        this.editForm.patchValue({
            orderDetailId: this.selectedData.orderDetailId,
            orderId: this.selectedData.orderId,
            inventoryNumber: this.selectedData.inventoryNumber,
            manufacturerNumber: this.selectedData.manufacturerNumber,
            inventoryDesc: this.selectedData.inventoryDesc,
            quantityReceived: this.selectedData.quantityReceived,
            totalReceived: this.selectedData.totalReceived,
            inventoryLocationId: this.selectedData.inventoryLocationId ? this.selectedData.inventoryLocationId : this.selectedData.warehouseId,
            quantity: this.selectedData.quantity,
            usedPartQuantity: this.selectedData.usedPartQuantity,
            quantityBilled: this.selectedData.quantityBilled,
            price: this.selectedData.price,
            warehouseId: this.selectedData.warehouseId

        });
    }
    protected save(dataObj: OrderDetailsBus) {

        let busObj: OrderDetailsBus = new OrderDetailsBus(dataObj);
        //   busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //   busObj.setParentId(this._parentId);
        //  data.referenceId = this._parentId;
        //this.svc_data.s.saveInvoiceLine(busObj).subscribe(data => {
        //});
    }
    receiveAll() {
        if (this.gridData && this.gridData.length) {

            for (let i = 0; i < this.gridData.length; i++) {
                //if (this.gridData[i].isPart) {
                    if (this.gridData[i].totalReceived < this.gridData[i].quantity) {
                        this.gridData[i].quantityReceived = this.gridData[i].quantity - this.gridData[i].totalReceived;
                        this.gridData[i].inventoryLocationId = this.gridData[i].inventoryLocationId ? this.gridData[i].inventoryLocationId : this.gridData[i].warehouseId
                        this.gridData[i].isUpdated = true;
                        this.sendParentMessage(MessageType.changed);
                    //}

                }
            }

        }

    }
    checkQuantityReceived(event, dataItem: OrderDetailsBus, editForm: UntypedFormGroup, field) {
        if ((editForm.get('quantity').value < (editForm.get('quantityReceived').value + (editForm.get('totalReceived').value == null ? 0 : editForm.get('totalReceived').value))) && !this.rights.ReceiveMoreQuantityThenOrdered) {
            this.notify("You cannot receive more items than were ordered.", "E", true);
            this.cancelHandler();
        }
    }

    addNewReceiving(){
            this.newReceiving.emit(true);
    }
}
